import { render, staticRenderFns } from "./TenantDialogChangeParent.vue?vue&type=template&id=2cd863a6"
import script from "./TenantDialogChangeParent.vue?vue&type=script&lang=js"
export * from "./TenantDialogChangeParent.vue?vue&type=script&lang=js"
import style0 from "./TenantDialogChangeParent.vue?vue&type=style&index=0&id=2cd863a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports